import type { ReactNode } from "react";
import type { DataTab } from "./dataTab.ts";
import { CurveIcon } from "./CurveIcon.tsx";
import { TimeSeriesIcon } from "./TimeSeriesIcon.tsx";
import { PatternIcon } from "./PatternIcon.tsx";
import { PollutantIcon } from "./PollutantIcon.tsx";
import { LandUseIcon } from "./LandUseIcon.tsx";
import { LidControlIcon } from "./LidControlIcon.tsx";
import { AquiferIcon } from "./AquiferIcon.tsx";
import { SnowIcon } from "./SnowIcon.tsx";
import { ClimateIcon } from "./ClimateIcon.tsx";
import { TransectIcon } from "./TransectIcon.tsx";
import { HydrographIcon } from "./HydrographIcon.tsx";
import { ControlRuleIcon } from "./ControlRuleIcon.tsx";
import { StreetIcon } from "./StreetIcon.tsx";
import { InletIcon } from "./InletIcon.tsx";

/** One icon per `DataTab`, shared by the dropdown menu and the dialog title it opens. */
export const DATA_TAB_ICONS: Record<DataTab, ReactNode> = {
  curves: <CurveIcon />,
  timeseries: <TimeSeriesIcon />,
  patterns: <PatternIcon />,
  pollutants: <PollutantIcon />,
  landuses: <LandUseIcon />,
  lidcontrols: <LidControlIcon />,
  aquifers: <AquiferIcon />,
  snowpacks: <SnowIcon />,
  climatology: <ClimateIcon />,
  transects: <TransectIcon />,
  hydrographs: <HydrographIcon />,
  controlrules: <ControlRuleIcon />,
  streets: <StreetIcon />,
  inlets: <InletIcon />,
};
